<script>
import { inventoryMethods } from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Stock',
  components: {},
  data() {
    return {
      /* ------------- table product props ------------------- */
      tableheadersproducts: [
        { key: 'name', label: 'Nombre:', class: 'mw-100' },
        { key: 'id_ext1', label: 'Extensión:', class: 'mw-100' },
        { key: 'existence', label: 'Existencia:', class: 'mw-100' },
        { key: 'batchs', label: 'Lotes:', class: 'ws-100' },
      ],
      /* ------------- table inventory props ------------------- */
      tableheaders: [
        { key: 'name', label: 'Nombre'},
        { key: 'reference', label: 'Referencia'},
        { key: 'id_ext1', label: 'Extensión'},
        { key: 'existence', label: 'Existencia'},
        { key: 'actions', label: 'Acciones' },
      ],
      totalRows: 100,
      currentPage: 1,
      perpage: 5,
      pageOptions: [5, 15, 50, 100, 1000],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: 'name',
      infoStockModal: {
        id: 'info-stock-modal',
        title: '',
        content: '',
      },
      items_by_batch: [],
      options: [
        { text: 'Nombre', value: 'name' },
        { text: 'Referencia', value: 'reference' },
        { text: 'Serial/Lote', value: 'batchs' },
      ],
      /* --------------------------------------------- */
    }
  },
  computed: {
    ...mapGetters({
      stock: 'retina/inventory/stock',
      total_stock: 'retina/inventory/total_stock',
    }),
    sortOptions() {
      // Create an options list from our tableheaders
      return this.tableheaders
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key }
        })
    },
  },
  mounted() {
    this.totalRows = this.total_stock
    for (let i = 0; i < 100; i++) {
      this.items_by_batch[i] = 0
    }
  },
  watch: {
    total_stock() {
      this.totalRows = this.total_stock
    },
  },
  methods: {
    ...inventoryMethods,
    has_serial(batchs) {
      if (batchs.serials.length > 0) return true
      return false
    },
    quantity(list) {
      // let i = 0
      // list.forEach((dict) => (i += dict.quantity))
      // return i
      return list.map(x => x.serials.length > 0 ? x.serials.length : x.quantity).reduce((total, cant) => total + cant, 0)
    },
    verify_quantity(batchs, index) {
      if (this.items_by_batch[index] == 0) return null
      if (
        batchs.quantity >= this.items_by_batch[index] &&
        this.items_by_batch[index] > 0
      )
        return true
      return false
    },
    info(item, index, button) {
      this.infoStockModal.title = item.reference
      this.infoStockModal.content = item
      this.$root.$emit('bv::show::modal', this.infoStockModal.id, button)
    },
    resetinfoStockModal() {
      this.infoStockModal.title = ''
      this.infoStockModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    proccessRemoveItemInStockByLote(item, batch, index) {
      this.removeItemInStockByLote({
        item: item,
        batch: batch,
        lot_quantity: this.items_by_batch[index],
      })
      this.items_by_batch[index] = 0
    },
  },
}
</script>

<template>
  <b-card no-body class="p-2">
    <b-card-title>  
      <i class="fas fa-dolly-flatbed"></i>
      Productos contados
    </b-card-title>
    <b-card-body class="p-0 px-1">
      <div class="row mb-2">
        <b-col lg="12" xl="6">
          <b-form-group
            label="Buscar"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
              ></b-form-input>

              <b-input-group-append>
                <b-button size="sm" :disabled="!filter" @click="filter = ''">
                  Limpiar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="10" xl="6">
          <b-form-group
            v-model="sortDirection"
            label="Buscar por:"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              v-model="filterOn"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="radio-inline"
              class="mt-1"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </div>
      <b-col lg="6" class="my-1 d-md-none px-0">
        <b-form-group
          label="Ordenar:"
          label-for="sort-by-select"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sort-by-select"
              v-model="sortBy"
              :options="sortOptions"
              :aria-describedby="ariaDescribedby"
              class="w-75"
            >
              <template #first>
                <option value="">Ninguno</option>
              </template>
            </b-form-select>

            <b-form-select
              v-model="sortDesc"
              :disabled="!sortBy"
              :aria-describedby="ariaDescribedby"
              size="sm"
              class="w-25"
            >
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
      <div class="row mt-3" style="color: #F28C02">
          Mostrando
        {{ !totalRows ? 0 : (currentPage - 1) * perpage + 1 }} -
        {{
          !totalRows
            ? 0
            : currentPage * perpage >= totalRows
            ? totalRows
            : currentPage * perpage
        }}
        de {{ totalRows }}
        productos
      </div>

      <div class="row mt-3">
        <b-table
          :items="stock"
          :fields="tableheaders"
          :current-page="currentPage"
          :per-page="perpage"
          :filter="filter"
          :filter-included-fields="[filterOn]"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="Sin registros para mostrar"
          empty-filtered-text="No se encontraron registros"
          stacked="md"
          show-empty
          small
          responsive
          sort-icon-left
          @filtered="onFiltered"
        >
          <template v-slot:cell(existence)="row">
            {{ quantity(row.item.batchs) }}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              :id="`update-btn-${row.index}`"
              @click="info(row.item, row.index, $event.target)"
              variant="outline-warning btn-transparent"
              size="xs"
            >
              <i class="fe-edit fe-2x"></i>
            </b-button>
          </template>
        </b-table>
        <!-- Info modal -->
        <b-modal
          :id="infoStockModal.id"
          :title="infoStockModal.title"
          @hide="resetinfoStockModal"
          hide-footer
          body-class="p-0"
        >
          <b-table
            class="table-sm"
            stacked
            :fields="tableheadersproducts"
            :items="[infoStockModal.content]"
          >
            <template v-slot:cell(id_ext1)="row">
              {{ row.item.ext_description }} {{ row.item.id_ext1 }}
            </template>
            <template v-slot:cell(existence)="row">
              {{ quantity(row.item.batchs) }}
            </template>
            <template v-slot:cell(batchs)="row">
              <b-list-group flush>
                <b-list-group-item
                  v-for="(c, index) in row.item.batchs"
                  :key="c.batch"
                  class="p-0"
                >
                  <div v-if="c.quantity != 0">
                    Lote: <b-badge variant="secondary">{{ c.batch }}</b-badge> (
                    {{ c.quantity }} )
                    <div v-if="!has_serial(c)">
                      <b-input-group size="sm">
                        <b-form-input
                          @keyup.13.prevent="proccessRemoveItemInStockByLote(row.item,c.batch,index)"
                          @keyup.enter.prevent="proccessRemoveItemInStockByLote(row.item,c.batch,index)"
                          @keyup.tab="proccessRemoveItemInStockByLote(row.item,c.batch,index)"
                          v-model="items_by_batch[index]"
                          type="number"
                          :state="verify_quantity(c, index)"
                        ></b-form-input>
                        <b-input-group-append>
                          <!-- {{items_by_batch}} -->
                          <b-button
                            v-b-tooltip.hover.v-primary.bottom="'Devolver a Existencias'"
                            @click="
                              proccessRemoveItemInStockByLote(
                                row.item,
                                c.batch,
                                index
                              )
                            "
                            :disabled="!verify_quantity(c, index)"
                            variant="link"
                            size="sm"
                            class="ml-1 d-inline align-items-center"
                          >
                            <i class="fas fa-minus-circle mr-1"></i> Existencias
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                  <div v-else class="text-muted text-center p-1">
                    Sin cantidades
                  </div>
                  <div v-if="has_serial(c)">
                    <h6>Seriales: </h6>
                    <ul class="list-unstyled">
                      <li v-for="(s, index_s) in c.serials" :key="s">
                        <b-badge variant="success">{{ s }}</b-badge>
                        <b-button
                          v-b-tooltip.hover.v-primary.bottom="'Devolver a Existencias'"
                          @click="
                            removeItemInStockBySerial({
                              item: row.item,
                              batch: c.batch,
                              assurance: index_s,
                              serial: s,
                            })
                          "
                          variant="link"
                          size="sm"
                          class="ml-1 d-inline align-items-center"
                        >
                          <i class="fas fa-minus-circle mr-1"></i> Existencias
                        </b-button>
                      </li>
                    </ul>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </template>
          </b-table>
        </b-modal>
      </div>
      <b-row class="mb-2">
        <b-col sm="6" lg="6" xl="6">
            Registros<span class="d-none d-lg-inline"> por página</span>
            <b-form-select
              id="per-page-select"
              v-model="perpage"
              :options="pageOptions"
              size="sm"
              class="ml-2"
              style="max-width: 60px"
            ></b-form-select>
        </b-col>
        <b-col sm="6" lg="6" xl="6">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perpage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
